import React from 'react';
import { useTranslation } from 'react-i18next';
import { TextField, Grid, MenuItem } from '@mui/material';

// Insurance option values (stored in English for database consistency)
const insuranceOptionValues = [
  'Yes',
  'No',
  "I'm an attorney or workman's compensation patient"
];

export default function Step2Insurance({ formData, onChange, fieldErrors = {} }) {
  const { t } = useTranslation('insurance');
  
  // Map option values to translated labels
  const getOptionLabel = (value) => {
    switch(value) {
      case 'Yes': return t('options.yes');
      case 'No': return t('options.no');
      case "I'm an attorney or workman's compensation patient": return t('options.attorneyWorkersComp');
      default: return value;
    }
  };
  
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <TextField
          select
          required
          label={t('labels.hasInsurance')}
          fullWidth
          value={formData.has_insurance || ''}
          onChange={e => onChange({ has_insurance: e.target.value })}
          error={!!fieldErrors.has_insurance}
          helperText={fieldErrors.has_insurance || ''}
        >
          {insuranceOptionValues.map(opt => <MenuItem key={opt} value={opt}>{getOptionLabel(opt)}</MenuItem>)}
        </TextField>
      </Grid>
      {formData.has_insurance === "I'm an attorney or workman's compensation patient" && (
        <>
          <Grid item xs={12} sm={6}>
            <TextField
              required
              label={t('labels.attorneyName')}
              fullWidth
              value={formData.attorney_name || ''}
              onChange={e => onChange({ attorney_name: e.target.value })}
              error={!!fieldErrors.attorney_name}
              helperText={fieldErrors.attorney_name || ''}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              required
              label={t('labels.adjusterName')}
              fullWidth
              value={formData.adjuster_name || ''}
              onChange={e => onChange({ adjuster_name: e.target.value })}
              error={!!fieldErrors.adjuster_name}
              helperText={fieldErrors.adjuster_name || ''}
            />
          </Grid>
        </>
      )}
      
      {/* Only show insurance fields when has_insurance is 'Yes' */}
      {formData.has_insurance === 'Yes' && (
        <>
          <Grid item xs={12} sm={6}>
            <TextField
              required
              label={t('labels.primaryInsurance')}
              fullWidth
              value={formData.primary_insurance || ''}
              onChange={e => onChange({ primary_insurance: e.target.value })}
              error={!!fieldErrors.primary_insurance}
              helperText={fieldErrors.primary_insurance || ''}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              label={t('labels.groupNumber')}
              fullWidth
              value={formData.group_number || ''}
              onChange={e => onChange({ group_number: e.target.value })}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              required
              label={t('labels.memberId')}
              fullWidth
              value={formData.member_id || ''}
              onChange={e => onChange({ member_id: e.target.value })}
              error={!!fieldErrors.member_id}
              helperText={fieldErrors.member_id || ''}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              required
              label={t('labels.subscriberName')}
              fullWidth
              value={formData.subscriber_name || ''}
              onChange={e => onChange({ subscriber_name: e.target.value })}
              error={!!fieldErrors.subscriber_name}
              helperText={fieldErrors.subscriber_name || ''}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              required
              label={t('labels.subscriberDOB')}
              type="date"
              InputLabelProps={{ shrink: true }}
              fullWidth
              value={formData.subscriber_dob || ''}
              onChange={e => onChange({ subscriber_dob: e.target.value })}
              error={!!fieldErrors.subscriber_dob}
              helperText={fieldErrors.subscriber_dob || ''}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              select
              label={t('labels.hasSecondaryInsurance')}
              fullWidth
              value={formData.has_secondary_insurance || ''}
              onChange={e => onChange({ has_secondary_insurance: e.target.value })}
            >
              <MenuItem value="Yes">{t('options.yes')}</MenuItem>
              <MenuItem value="No">{t('options.no')}</MenuItem>
            </TextField>
          </Grid>
        </>
      )}
      {formData.has_secondary_insurance === 'Yes' && (
        <>
          <Grid item xs={12} sm={6}>
            <TextField
              label={t('labels.secondaryInsuranceName')}
              fullWidth
              value={formData.secondary_insurance_name || ''}
              onChange={e => onChange({ secondary_insurance_name: e.target.value })}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              label={t('labels.secondaryGroupNumber')}
              fullWidth
              value={formData.secondary_group_number || ''}
              onChange={e => onChange({ secondary_group_number: e.target.value })}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              label={t('labels.secondaryMemberId')}
              fullWidth
              value={formData.secondary_member_id || ''}
              onChange={e => onChange({ secondary_member_id: e.target.value })}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              label={t('labels.secondarySubscriberName')}
              fullWidth
              value={formData.secondary_subscriber_name || ''}
              onChange={e => onChange({ secondary_subscriber_name: e.target.value })}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              label={t('labels.secondarySubscriberDOB')}
              type="date"
              InputLabelProps={{ shrink: true }}
              fullWidth
              value={formData.secondary_subscriber_dob || ''}
              onChange={e => onChange({ secondary_subscriber_dob: e.target.value })}
            />
          </Grid>
        </>
      )}
    </Grid>
  );
}
